module.exports = __webpack_public_path__ + "img/ico-download.d6a41928.svg";